var map = {
	"./boots/overall/black.jpg": "df20",
	"./gloves/overall/black.jpg": "123d",
	"./jackets/back/black.jpg": "ea43",
	"./jackets/chest/black.jpg": "fcac",
	"./jackets/elbow/black.jpg": "de6c",
	"./jackets/shoulder/black.jpg": "10e5",
	"./pants/hip/black.jpg": "8d31",
	"./pants/knee/black.jpg": "9aa0",
	"./pants/tailbone/black.jpg": "deeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee1";